import { Stack } from "@/components/ui";
import { ChatCard } from "./ChatCard";
import { FlujoCard } from "./FlujoCard";
import { useSolicitud } from "@/features/solicitudes/hooks/use-solicitud";
import { useSolicitudPolling } from "@/features/solicitudes/hooks/use-solicitud-polling";
import { autorizacionTerminada, enFlujoDeAutorizacion } from "../utils/estado-autorizacion";
import { AutorizacionDetalleHeader } from "./AutorizacionDetalleHeader";
import { ResumenSolicitudCard } from "./ResumenSolicitudCard";
import { AccionesAutorizadorCard } from "./AccionesAutorizadorCard";
import { AutorizacionTerminadaCard } from "./AutorizacionTerminadaCard";
import { Route } from "@/routes/_authed-tw/autorizacion/$id";

/**
 * Página de detalle desde el lado del autorizador. Reusa
 * `useSolicitud` (suspense, mismo cache que /solicitudes/$id) y agrega
 * polling de 5s vía `useSolicitudPolling`. Las mutations comparten esa
 * cache · hidratan con `setQueryData` para feedback instantáneo.
 *
 * El switch principal renderiza:
 *   · `AccionesAutorizadorCard` si la solicitud sigue activa en flujo.
 *   · `AutorizacionTerminadaCard`  si ya terminó (autorizada o baja).
 *   · Nada extra si está en otro estado (e.g. capturando datos).
 */
export function AutorizacionDetallePage() {
  const { id } = Route.useParams();
  const { data: sol } = useSolicitud(id);
  useSolicitudPolling(id, 5_000);

  const enFlujo = enFlujoDeAutorizacion(sol.estado);
  const terminada = autorizacionTerminada(sol.estado);

  return (
    <div className="w-full px-4 py-6 md:px-6">
      <AutorizacionDetalleHeader sol={sol} />
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-8">
          <Stack gap="md">
            <ResumenSolicitudCard sol={sol} />
            {sol.flujo ? <FlujoCard flujo={sol.flujo} /> : null}
            {enFlujo ? <AccionesAutorizadorCard id={id} /> : null}
            {terminada ? <AutorizacionTerminadaCard sol={sol} /> : null}
          </Stack>
        </div>
        <div className="col-span-12 lg:col-span-4">
          <ChatCard solicitudId={id} />
        </div>
      </div>
    </div>
  );
}
